import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { DataService } from '../services/data.service';
import { TrackAuthority } from '../models/trackauthority';
import { UtilService } from '../services/util.service';
import { CommentType } from '../models/commenttype.enum';
import { Comment } from '../models/comment';


@Component({
    selector: 'comment-dialog',
    templateUrl: './comment.component.html',
    styleUrls: ['./comment.component.scss']
})
export class CommentComponent implements OnChanges {

    @Input() display: boolean = false;
    @Input() authority: TrackAuthority;
    @Output() onClose: EventEmitter<void> = new EventEmitter<void>();
    
    comment: string;
    commentLength: number;
    validForSubmit: boolean;

    constructor(private dataService: DataService) { }

    ngOnChanges(changes: SimpleChanges): void {
        this.display = this.authority !== null;
        this.reset();
        if(this.authority !== null && this.authority !== undefined) {
            let commentList:Comment[] = UtilService.getFirstCommentOfTypes(this.authority.comments, [CommentType.PRIVATE]);
            if(commentList.length > 0) {
                this.comment = commentList.pop().text;
            }
        }
    }

    private reset(): void {
        this.comment = null;
        this.commentLength = 0;
        this.validForSubmit = false;
    }

    updateLength(newValue: string): void {
        newValue = newValue.trim();
        if (newValue.length > 0) {
            this.comment = newValue;
            this.commentLength = newValue.length;
            this.validForSubmit = true;
        } else {
            this.reset();
        }
    }

    onCancel(): void {
        this.close();
    }

    onSubmit(): void {
        if (this.validForSubmit) {
            this.dataService.addComment(this.authority, this.comment);
        }
        this.close();
    }

    close(): void {
        this.onClose.emit();
    }

}